webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loglevel = __webpack_require__(26);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	var _vue = __webpack_require__(297);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _SystemChecker = __webpack_require__(272);
	
	var _SystemChecker2 = _interopRequireDefault(_SystemChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_loglevel2.default.setLevel('debug', true);
	
	if (!window.SYSTEM_CHECK) {
	  window.SYSTEM_CHECK = {
	    exportUrl: 'http://demo.6connexlocal.com/event/system-check/export',
	    imageDownloadUrl: 'http://demo.6connexlocal.com/event/local-files/assets/images/speed-test.jpg',
	    cdnCheckUrl: 'http://demo.6connexlocal.com/event/local-files/assets/system-check/img/1x1.png',
	    realTimeServers: [{ name: 'rts1', url: 'https://demo.6connexlocal.com:8000' }],
	    videos: {
	      poster: 'http://cdn-akamai.6connex.com/files/6connex/v7-intro.png',
	      mp4: 'http://v7qa.6connex.com/upload/files/6connex/v7-intro.mp4',
	      webm: 'http://v7qa.6connex.com/upload/files/6connex/v7-intro.webm'
	    },
	    i18n: {
	      title: 'System Checker',
	      description: 'This system check covers standard platform functionality. It does not cover requirements for any 3rd party services that may be integrated into the experience.',
	      complete: 'Completed!',
	      checking: 'Checking...',
	      downloadCSV: 'Download CSV',
	      connectionSpeed: 'Connection Speed',
	      popUpBlocker: 'Popup Blocker Disabled',
	      screenResolution: 'Screen Resolution',
	      browserSize: 'Browser Size',
	      cdn: 'CDN Access',
	      cookieEnabled: 'Cookie Enabled',
	      browser: 'Web Browser',
	      operatingSystem: 'Operation System',
	      rts: 'Real Time Server Access',
	      videoPlayer: 'Video Player',
	      videoPlayerInit: 'Initializing video player...',
	      apiAccess: 'AWS API access',
	      results: {
	        popUpBlocker: 'Please disable your popup blocker. If you do not, some content may not display correctly for you.',
	        screenResolution: 'Your screen resolution is below the recommended minimum of 1024 x 768. If you do not raise your resolution, the UI may not fit completely into your browser window.',
	        browserSize: 'Your browser\'s current viewable area is less than 1000 pixels wide by 640 pixels high. While you may be able to see some of the Virtual Experience, you will not be able to see all essential elements. Please enlarge your browser window.',
	        cdn: 'It seems that you cannot connect to our CDN server to download the test file.',
	        cookieEnabled: 'Please use your browser settings to enable cookies. If you do not, certain features may not function properly.',
	        connectionSpeedBelowMinimum: 'Your connection speed is below the minimum 384Kbps to take advantage of a rich media experience. Minimum speed for a smooth experience is 800Kbps.',
	        connectionSpeedBelowMedium: 'Your connection speed is below the recommended 800Kbps for an optimum experience. While you can still participate in this virtual environment, some video and audio may not play smoothly for you.'
	      }
	    }
	  };
	}
	
	_loglevel2.default.info('System Check settings are ', window.SYSTEM_CHECK);
	
	new _vue2.default({
	  el: '#app',
	  template: '<SystemChecker/>',
	  components: { SystemChecker: _SystemChecker2.default }
	});

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(117)
	
	/* template */
	var __vue_template__ = __webpack_require__(292)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(65);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(67);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(66);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var abortController = new AbortController();
	var signal = abortController.signal;
	
	var fetchUrlWithTimeout = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url, timeout) {
	    var timeoutId, response, data;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            timeoutId = setTimeout(function () {
	              abortController.abort();
	            }, timeout);
	            _context.prev = 1;
	            _context.next = 4;
	            return fetch(url, { signal: signal });
	
	          case 4:
	            response = _context.sent;
	
	            if (response.ok) {
	              _context.next = 7;
	              break;
	            }
	
	            throw new Error('HTTP error! Status: ' + response.status);
	
	          case 7:
	
	            clearTimeout(timeoutId);_context.next = 10;
	            return response.text();
	
	          case 10:
	            data = _context.sent;
	            return _context.abrupt('return', { status: 'fulfilled', value: data, url: url });
	
	          case 14:
	            _context.prev = 14;
	            _context.t0 = _context['catch'](1);
	
	            if (!(_context.t0.name === 'AbortError')) {
	              _context.next = 19;
	              break;
	            }
	
	            console.error('Request aborted due to timeout');
	            return _context.abrupt('return', { status: 'rejected', reason: _context.t0.message, url: url });
	
	          case 19:
	            return _context.abrupt('return', { status: 'fulfilled', value: _context.t0.message, url: url });
	
	          case 20:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[1, 14]]);
	  }));
	
	  return function fetchUrlWithTimeout(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var fetchDataWithTimeout = function () {
	  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(urls) {
	    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
	    var promises, results;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            promises = urls.map(function (url) {
	              return fetchUrlWithTimeout(url, timeout);
	            });
	            _context2.prev = 1;
	            _context2.next = 4;
	            return _promise2.default.all(promises);
	
	          case 4:
	            results = _context2.sent;
	            return _context2.abrupt('return', results);
	
	          case 8:
	            _context2.prev = 8;
	            _context2.t0 = _context2['catch'](1);
	
	            console.error('Promise.all Error:', _context2.t0);
	
	          case 11:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined, [[1, 8]]);
	  }));
	
	  return function fetchDataWithTimeout(_x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var test = 0;
	
	exports.default = {
	  fetchUrlWithTimeout: fetchUrlWithTimeout,
	  fetchDataWithTimeout: fetchDataWithTimeout,
	  test: test
	};
	module.exports = exports.default;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _spin = __webpack_require__(91);
	
	var _spin2 = _interopRequireDefault(_spin);
	
	var _loglevel = __webpack_require__(26);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	var _ConnectionSpeed = __webpack_require__(276);
	
	var _ConnectionSpeed2 = _interopRequireDefault(_ConnectionSpeed);
	
	var _PopupBlocker = __webpack_require__(279);
	
	var _PopupBlocker2 = _interopRequireDefault(_PopupBlocker);
	
	var _CookieEnabled = __webpack_require__(277);
	
	var _CookieEnabled2 = _interopRequireDefault(_CookieEnabled);
	
	var _ScreenResolution = __webpack_require__(281);
	
	var _ScreenResolution2 = _interopRequireDefault(_ScreenResolution);
	
	var _BrowserSize = __webpack_require__(274);
	
	var _BrowserSize2 = _interopRequireDefault(_BrowserSize);
	
	var _WebBrowser = __webpack_require__(283);
	
	var _WebBrowser2 = _interopRequireDefault(_WebBrowser);
	
	var _OperationSystem = __webpack_require__(278);
	
	var _OperationSystem2 = _interopRequireDefault(_OperationSystem);
	
	var _CdnAccess = __webpack_require__(275);
	
	var _CdnAccess2 = _interopRequireDefault(_CdnAccess);
	
	var _RealTimeServerAccess = __webpack_require__(280);
	
	var _RealTimeServerAccess2 = _interopRequireDefault(_RealTimeServerAccess);
	
	var _VideoPlayer = __webpack_require__(282);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	var _ApiConnectionChecker = __webpack_require__(273);
	
	var _ApiConnectionChecker2 = _interopRequireDefault(_ApiConnectionChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_loglevel2.default.setLevel('debug');
	
	exports.default = {
	  name: 'system-checker',
	  data: function data() {
	    return {
	      completed: false,
	      checkers: {},
	      downloadUrl: '',
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    ConnectionSpeed: _ConnectionSpeed2.default,
	    PopupBlocker: _PopupBlocker2.default,
	    CookieEnabled: _CookieEnabled2.default,
	    ScreenResolution: _ScreenResolution2.default,
	    BrowserSize: _BrowserSize2.default,
	    WebBrowser: _WebBrowser2.default,
	    OperationSystem: _OperationSystem2.default,
	    CdnAccess: _CdnAccess2.default,
	    RealTimeServerAccess: _RealTimeServerAccess2.default,
	    VideoPlayer: _VideoPlayer2.default,
	    ApiConnectionChecker: _ApiConnectionChecker2.default
	  },
	  mounted: function mounted() {
	    var spinner = new _spin2.default({
	      color: '#333',
	      width: 2,
	      length: 0,
	      radius: 5,
	      top: '50%',
	      left: '6.5%'
	    }).spin();
	
	    this.$refs.statusIndicator.appendChild(spinner.el);
	  },
	
	  methods: {
	    registerChecker: function registerChecker(checker) {
	      _loglevel2.default.debug('Checker[' + checker.name + '] registered');
	      this.checkers[checker.name] = { completed: false };
	    },
	    completeChecker: function completeChecker(checker) {
	      _loglevel2.default.debug('Checker[' + checker.name + '] completed');
	      this.checkers[checker.name] = { completed: true, result: checker.result };
	
	      var allCompleted = true;
	
	      for (var name in this.checkers) {
	        var status = this.checkers[name];
	        if (!status.completed) {
	          allCompleted = false;
	        }
	      }
	      this.completed = allCompleted;
	      if (this.completed) {
	        this.setupDownloadButton();
	      }
	    },
	    setupDownloadButton: function setupDownloadButton() {
	      _loglevel2.default.debug('Results are', this.checkers);
	      var results = { checkers: [] };
	      for (var name in this.checkers) {
	        var checker = this.checkers[name];
	        results.checkers.push({
	          name: name,
	          result: checker.result
	        });
	      }
	
	      this.downloadUrl = window.SYSTEM_CHECK.exportUrl + '?results=' + (0, _stringify2.default)(results);
	    }
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(67);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(66);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	var _utils = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'api-connection-checker';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: []
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  computed: {
	    cdnCheckUrl: function cdnCheckUrl() {
	      return window.SYSTEM_CHECK.cdnCheckUrl;
	    },
	    region: function region() {
	      if (window.location.hostname.includes('.com')) {
	        return 'us-west-1';
	      } else if (window.location.hostname.includes('.us')) {
	        return 'us-east-1';
	      }
	      return 'eu-central-1';
	    },
	    domain: function domain() {
	      if (window.location.hostname.includes('.com')) {
	        return '6connex.com';
	      } else if (window.location.hostname.includes('.us')) {
	        return '6connex.us';
	      }
	      return '6connex.eu';
	    }
	  },
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var pamsApiUrl, apiGatewayApiUrl, urls;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              pamsApiUrl = 'https://api-' + _this.region + '.' + _this.domain;
	              apiGatewayApiUrl = 'https://apigateway.' + _this.domain;
	              urls = [pamsApiUrl, apiGatewayApiUrl];
	
	
	              _this.checkApisConnection(urls);
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    checkApisConnection: function checkApisConnection(apiUrls) {
	      var _this2 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var responses;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return (0, _utils.fetchDataWithTimeout)(apiUrls);
	
	              case 3:
	                responses = _context2.sent;
	
	                responses.forEach(function (response) {
	                  var status = response.status,
	                      url = response.url;
	
	
	                  if (status === 'fulfilled') {
	                    _this2.result.value = 'passed';
	                  } else {
	                    _this2.result.value = 'failed';
	                    _this2.result.text.push('Can\'t access ' + url);
	                  }
	                });
	                _context2.next = 10;
	                break;
	
	              case 7:
	                _context2.prev = 7;
	                _context2.t0 = _context2['catch'](0);
	
	                console.error('Fetch error:', _context2.t0);
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[0, 7]]);
	      }))();
	    }
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'browser-size';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var $window = (0, _jquery2.default)(window);
	    var width = $window.width();
	    var height = $window.height();
	    this.result.text = width + ' x ' + height;
	    this.result.value = width < 1000 || height < 640 ? 'failed' : 'passed';
	    this.$emit('completed', { name: checkerName, result: this.result.text });
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'cdn-access';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  computed: {
	    cdnCheckUrl: function cdnCheckUrl() {
	      return window.SYSTEM_CHECK.cdnCheckUrl;
	    }
	  },
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var img = new Image();
	    img.onload = function () {
	      _this.result.value = 'passed';
	      _this.$emit('completed', { name: checkerName, result: 'passed' });
	    };
	    img.onerror = function () {
	      _this.result.value = 'failed';
	      _this.$emit('completed', { name: checkerName, result: 'failed' });
	    };
	    img.src = this.cdnCheckUrl + '?_=' + new Date().getTime();
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _spin = __webpack_require__(91);
	
	var _spin2 = _interopRequireDefault(_spin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'check-status',
	  props: ['result'],
	  mounted: function mounted() {
	    var spinner = new _spin2.default({
	      color: '#333',
	      width: 2,
	      length: 0,
	      radius: 5,
	      top: '60%',
	      left: '82%'
	    }).spin();
	
	    if (this.$refs.holder) {
	      this.$refs.holder.appendChild(spinner.el);
	    }
	
	    this.$watch('result', function (newVal) {
	      if (newVal && spinner) {
	        spinner.stop();
	      }
	    });
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loglevel = __webpack_require__(26);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'connection-speed';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (!window.SYSTEM_CHECK.imageDownloadUrl) {
	      _loglevel2.default.error('No image download URL found');
	      return;
	    }
	
	    _loglevel2.default.debug('Starting connection speed test');
	
	    var startTime = new Date().getTime();
	    var img = new Image();
	    img.onload = function () {
	      var size = 1741.802 * 8;
	      var duration = new Date().getTime() - startTime;
	      var speed = Math.round(size * 1000 / duration);
	      _this.result.text = speed + ' Kbps';
	
	      if (speed < 384) {
	        _this.result.value = 'failed';
	      } else if (speed >= 384 && speed <= 800) {
	        _this.result.value = 'warning';
	      } else if (speed > 800) {
	        _this.result.value = 'passed';
	      }
	      _this.$emit('completed', { name: checkerName, result: _this.result.text });
	    };
	    img.onerror = function () {
	      _this.result.value = 'failed';
	      _this.result.text = 'Connection failed';
	      _this.$emit('completed', { name: checkerName, result: _this.result.text });
	    };
	    img.src = window.SYSTEM_CHECK.imageDownloadUrl + '?_=' + startTime;
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'cookie-enabled';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    this.result.value = window.navigator.cookieEnabled ? 'passed' : 'failed';
	    this.$emit('completed', { name: checkerName, result: this.result.value });
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uaParserJs = __webpack_require__(93);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'operating-system';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var os = new _uaParserJs2.default().getResult().os;
	    this.result.text = os.name + ' ' + os.version;
	    var supportedOSs = ['Android', 'iOS', 'Mac OS', 'Windows'];
	    this.result.value = supportedOSs.indexOf(os.name) >= 0 ? 'passed' : 'failed';
	    this.$emit('completed', { name: checkerName, result: this.result.text });
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'popup-blocker';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var options = 'directotries=no,location=no,menubar=no,resizable=no,scrollbars=no,' + 'status=no,titlebar=no,toolbar=no,width=1px,height=1px,top=300000000,left=30000000';
	    var isiPad = window.navigator.userAgent.match(/iPad/i) != null;
	    var vm = this;
	    var popUp = null;
	
	    setTimeout(function () {
	      popUp = window.open('about:blank', '_blank', options);
	      if (isiPad) {
	        if (popUp) {
	          vm.result.value = 'passed';
	          vm.status = 'completed';
	          this.$emit('completed', { name: checkerName, result: this.result.value });
	          if (window.focus) {
	            popUp.focus();
	          }
	          popUp.close();
	        }
	      }
	    }, 2000);
	
	    setTimeout(function () {
	      if (vm.status === 'completed') {
	        return;
	      }
	
	      var popUpBlockerEnabled = true;
	      if (popUp) {
	        var isChrome = window.navigator.userAgent.indexOf('Chrome');
	        popUpBlockerEnabled = isChrome && popUp.screenX === 0;
	
	        if (!isiPad) {
	          popUp.close();
	        }
	
	        if (!isChrome && !isiPad) {
	          popUpBlockerEnabled = false;
	        }
	      }
	
	      vm.result.value = popUpBlockerEnabled ? 'failed' : 'passed';
	      vm.$emit('completed', { name: checkerName, result: vm.result.value });
	    }, 5000);
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loglevel = __webpack_require__(26);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	var _socket = __webpack_require__(205);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'real-time-server-access';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n,
	      servers: {},
	      maxAttempts: 2
	    };
	  },
	
	  computed: {
	    failedServers: function failedServers() {
	      var failures = [];
	      for (var name in this.servers) {
	        var result = this.servers[name];
	        if (result.result === 'failed') {
	          failures.push(name);
	        }
	      }
	      _loglevel2.default.debug('Failed servers are ', failures);
	      return failures;
	    }
	  },
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var servers = window.SYSTEM_CHECK.realTimeServers;
	    servers.forEach(function (server) {
	      _this.$set(_this.servers, server.name, { name: server.name, status: 'in-progress' });
	      _this.connectServer(server);
	    });
	  },
	
	  methods: {
	    connectServer: function connectServer(server) {
	      var _this2 = this;
	
	      var clientTime = new Date().getTime();
	      var socket = (0, _socket2.default)(server.url, { query: { ping: true } });
	
	      socket.on('ping', function (res) {
	        var endTime = new Date().getTime();
	        _loglevel2.default.debug('RTS ' + server.url + ' pinged back.');
	        _this2.$set(_this2.servers, server.name, {
	          name: server.name,
	          status: 'finished',
	          result: 'passed',
	          serverArriveTime: res.serverTime - clientTime,
	          pingTime: endTime - clientTime
	        });
	        _this2.checkStatus();
	        setTimeout(function () {
	          socket.disconnect();
	        }, 50);
	      });
	
	      socket.on('reconnecting', function (attempts) {
	        if (attempts > _this2.maxAttempts) {
	          _loglevel2.default.debug('RTS ' + server.url + ' max attempts reached.');
	          socket.disconnect();
	          _this2.$set(_this2.servers, server.name, {
	            name: server.name,
	            status: 'finished',
	            result: 'failed'
	          });
	          _this2.checkStatus();
	        }
	      });
	    },
	    checkStatus: function checkStatus() {
	      var allFinished = true;
	      var hasFailure = false;
	      for (var name in this.servers) {
	        var result = this.servers[name];
	        if (result.status !== 'finished') {
	          allFinished = false;
	        }
	        if (result.result === 'failed') {
	          hasFailure = true;
	        }
	      }
	
	      _loglevel2.default.debug('RTS all finished? ' + allFinished + '. Has failure? ' + hasFailure);
	
	      if (allFinished) {
	        this.result.value = hasFailure ? 'failed' : 'passed';
	        var resultSummary = hasFailure ? 'Failed servers: ' + this.failedServers.join(', ') : 'passed';
	        this.$emit('completed', { name: checkerName, result: resultSummary });
	      }
	    }
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'screen-resolution';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var width = window.screen.width;
	    var height = window.screen.height;
	    this.result.text = width + ' x ' + height;
	    this.result.value = width < 1024 || height < 730 ? 'failed' : 'passed';
	    this.$emit('completed', { name: checkerName, result: this.result.text });
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(64);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _loglevel = __webpack_require__(26);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	var _video = __webpack_require__(107);
	
	var _video2 = _interopRequireDefault(_video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'video-player';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        error: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n,
	      playerReady: false,
	      closed: false
	    };
	  },
	
	  methods: {
	    closePlayer: function closePlayer(player) {
	      player.dispose();
	      this.closed = true;
	    }
	  },
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var vm = this;
	    try {
	      (0, _video2.default)('testVideo').ready(function () {
	        var player = this;
	        player.volume(0.1);
	
	
	        setTimeout(function () {
	          player.play();
	          vm.playerReady = true;
	        }, 1500);
	
	        player.on('ended', function () {
	          vm.result.value = 'passed';
	          vm.$emit('completed', { name: checkerName, result: 'passed' });
	          vm.closePlayer(player);
	        });
	
	        player.on('error', function () {
	          _loglevel2.default.error('Player error', player.error());
	          vm.result.value = 'failed';
	          vm.$emit('completed', { name: checkerName, result: 'Failed. Error: ' + player.error().message });
	        });
	      });
	    } catch (err) {
	      vm.result.value = 'failed';
	      var errorDetail = (0, _stringify2.default)(err);
	      vm.result.error = 'Fail to initialize Video Player. Error detail: ' + errorDetail;
	      vm.$emit('completed', { name: checkerName, result: 'Failed. Error: ' + errorDetail });
	    }
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uaParserJs = __webpack_require__(93);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	var _CheckerStatus = __webpack_require__(12);
	
	var _CheckerStatus2 = _interopRequireDefault(_CheckerStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkerName = 'web-browser';
	
	exports.default = {
	  name: checkerName,
	  data: function data() {
	    return {
	      status: 'in-progress',
	      result: {
	        value: '',
	        text: ''
	      },
	      i18n: window.SYSTEM_CHECK.i18n
	    };
	  },
	
	  components: {
	    CheckerStatus: _CheckerStatus2.default
	  },
	  created: function created() {
	    this.$emit('initialized', { name: checkerName });
	  },
	  mounted: function mounted() {
	    var ua = new _uaParserJs2.default().getResult();
	    var browser = ua.browser;
	    var device = ua.device;
	    var browserMajorVersion = parseInt(browser.major);
	    var os = ua.os;
	    var passed = false;
	    if (os.name === 'Windows') {
	      if (browser.name === 'IE' && browserMajorVersion >= 9 || browser.name === 'Chrome' && browserMajorVersion >= 26 || browser.name === 'Firefox' && browserMajorVersion > 3) {
	        passed = true;
	      }
	    } else if (os.name === 'Mac OS') {
	      if (browser.name === 'Safari' && browserMajorVersion >= 5 || browser.name === 'Chrome' && browserMajorVersion >= 26 || browser.name === 'Firefox' && browserMajorVersion > 3) {
	        passed = true;
	      }
	    } else if (os.name === 'Android') {
	      if (browser.name === 'Chrome' && browserMajorVersion >= 26) {
	        passed = true;
	      }
	    } else {
	      if (device.vendor === 'Apple' && (device.model === 'iPad' || device.model === 'iPhone')) {
	        passed = browser.name === 'Mobile Safari';
	      }
	    }
	
	    this.result.text = browser.name + ' ' + browser.version;
	    this.result.value = passed ? 'passed' : 'failed';
	    this.$emit('completed', { name: checkerName, result: this.result.text });
	  }
	};
	module.exports = exports.default;

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(193)
	
	/* script */
	__vue_exports__ = __webpack_require__(113)
	
	/* template */
	var __vue_template__ = __webpack_require__(285)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(114)
	
	/* template */
	var __vue_template__ = __webpack_require__(293)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(115)
	
	/* template */
	var __vue_template__ = __webpack_require__(287)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(116)
	
	/* template */
	var __vue_template__ = __webpack_require__(290)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(118)
	
	/* template */
	var __vue_template__ = __webpack_require__(284)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(119)
	
	/* template */
	var __vue_template__ = __webpack_require__(289)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(120)
	
	/* template */
	var __vue_template__ = __webpack_require__(295)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(121)
	
	/* template */
	var __vue_template__ = __webpack_require__(294)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(194)
	
	/* script */
	__vue_exports__ = __webpack_require__(122)
	
	/* template */
	var __vue_template__ = __webpack_require__(291)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-765859a9"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(123)
	
	/* template */
	var __vue_template__ = __webpack_require__(288)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(195)
	
	/* script */
	__vue_exports__ = __webpack_require__(124)
	
	/* template */
	var __vue_template__ = __webpack_require__(296)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d4ca5ed6"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(125)
	
	/* template */
	var __vue_template__ = __webpack_require__(286)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.connectionSpeed))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "result"
	  }, [_vm._v(_vm._s(_vm.result.text))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'warning'),
	      expression: "result.value === 'warning'"
	    }],
	    staticClass: "alert alert-warning"
	  }, [_vm._v(_vm._s(_vm.i18n.results.connectionSpeedBelowMedium))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'failed'),
	      expression: "result.value === 'failed'"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v(_vm._s(_vm.i18n.results.connectionSpeedBelowMinimum))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "system-checker"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', [_c('span', {
	    staticClass: "glyphicon glyphicon-cog"
	  }), _vm._v(" " + _vm._s(_vm.i18n.title))]), _vm._v(" "), _c('p', {
	    staticClass: "introduction"
	  }, [_vm._v(_vm._s(_vm.i18n.description))]), _vm._v(" "), _c('div', {
	    staticClass: "overall-status"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "status"
	  }, [_c('strong', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.completed),
	      expression: "!completed"
	    }],
	    staticClass: "in-progress"
	  }, [_vm._v(_vm._s(_vm.i18n.checking))]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.completed),
	      expression: "!completed"
	    }],
	    ref: "statusIndicator"
	  }), _vm._v(" "), _c('strong', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.completed),
	      expression: "completed"
	    }]
	  }, [_vm._v(_vm._s(_vm.i18n.complete))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.completed),
	      expression: "completed"
	    }],
	    staticClass: "pull-right"
	  }, [_c('a', {
	    staticClass: "btn btn-link btn-download",
	    attrs: {
	      "target": "_blank",
	      "href": _vm.downloadUrl
	    }
	  }, [_vm._v(_vm._s(_vm.i18n.downloadCSV))])])])])]), _vm._v(" "), _c('connection-speed', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('popup-blocker', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('cookie-enabled', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('screen-resolution', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('browser-size', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('web-browser', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('operation-system', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('cdn-access', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('real-time-server-access', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('api-connection-checker', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  }), _vm._v(" "), _c('video-player', {
	    on: {
	      "initialized": _vm.registerChecker,
	      "completed": _vm.completeChecker
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.browser))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_vm._v(_vm._s(_vm.result.text))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  })])
	}]}

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.browserSize))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_vm._v(_vm._s(_vm.result.text))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'failed'),
	      expression: "result.value === 'failed'"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v(_vm._s(_vm.i18n.results.browserSize))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.screenResolution))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_vm._v(_vm._s(_vm.result.text))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'failed'),
	      expression: "result.value === 'failed'"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v(_vm._s(_vm.i18n.results.screenResolution))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.cookieEnabled))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'failed'),
	      expression: "result.value === 'failed'"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v(_vm._s(_vm.i18n.results.cookieEnabled))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.cdn))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'failed'),
	      expression: "result.value === 'failed'"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v("\n        " + _vm._s(_vm.i18n.results.cdn) + " " + _vm._s(_vm.cdnCheckUrl) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.rts))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "servers"
	  }, _vm._l((_vm.servers), function(server) {
	    return _c('div', {
	      staticClass: "server"
	    }, [_c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-xs-7"
	    }, [_vm._v(_vm._s(server.name))]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-5"
	    }, [_c('checker-status', {
	      attrs: {
	        "result": server.result
	      }
	    })], 1)])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "indicator"
	  }, [(_vm.result === '') ? _c('div', {
	    ref: "holder"
	  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.result === 'failed') ? _c('div', {
	    staticClass: "indicator error"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-remove-sign"
	  })]) : _vm._e(), _vm._v(" "), (_vm.result === 'warning') ? _c('div', {
	    staticClass: "indicator warning"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-exclamation-sign"
	  })]) : _vm._e(), _vm._v(" "), (_vm.result === 'passed') ? _c('div', {
	    staticClass: "indicator passed"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-ok-sign"
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.apiAccess))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _vm._l((_vm.result.text), function(text) {
	    return _c('div', {
	      key: text,
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-sm-12"
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.result.value === 'failed'),
	        expression: "result.value === 'failed'"
	      }],
	      staticClass: "alert alert-danger"
	    }, [_c('span', [_vm._v("\n          " + _vm._s(text) + "\n        ")])])])])
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.popUpBlocker))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.result.value === 'failed'),
	      expression: "result.value === 'failed'"
	    }],
	    staticClass: "alert alert-danger"
	  }, [_vm._v(_vm._s(_vm.i18n.results.popUpBlocker))])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.operatingSystem))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_vm._v(_vm._s(_vm.result.text))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  })])
	}]}

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "check-item"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-7"
	  }, [_vm._v(_vm._s(_vm.i18n.videoPlayer))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('checker-status', {
	    attrs: {
	      "result": _vm.result.value
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.closed),
	      expression: "!closed"
	    }],
	    staticClass: "row video-player"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.playerReady),
	      expression: "!playerReady"
	    }],
	    staticClass: "init-holder"
	  }, [_vm._v(_vm._s(_vm.i18n.videoPlayerInit))]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.playerReady),
	      expression: "playerReady"
	    }]
	  }, [_vm._m(0)]), _vm._v(" "), (_vm.result.error !== '') ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_vm._v(_vm._s(_vm.result.error))]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('video', {
	    staticClass: "video-js vjs-default-skin vjs-big-play-centered",
	    attrs: {
	      "id": "testVideo",
	      "controls": "",
	      "preload": "auto",
	      "width": "700",
	      "height": "393",
	      "poster": "http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.png",
	      "data-setup": "{}"
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": "http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.mp4",
	      "type": "video/mp4"
	    }
	  }), _vm._v(" "), _c('source', {
	    attrs: {
	      "src": "http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.webm",
	      "type": "video/webm"
	    }
	  })])
	}]}

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// system-check/js/app.js